/**
 * ============================================================================
 * MIGRATED FILE — DO NOT EDIT
 * ============================================================================
 *
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/shortContent/shortContentUtils.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 *
 * @migrated-to academy-content-ui
 * ============================================================================
 */

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/shortContent/shortContentUtils.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const mapShortProfessorToProfessor = language => ({
  id,
  name,
  image,
  description,
  organisation,
  organisationUrl,
  jobTitle
}) => {
  return {
    contentId: id,
    descriptions: {
      [language.toLowerCase()]: description
    },
    id,
    image: image || '',
    metadata: [],
    name,
    organisation: organisation || undefined,
    organisationUrl: organisationUrl || undefined,
    jobTitle: jobTitle || undefined,
    updatedAt: 0
  };
};